import { defineMessages } from 'react-intl';

export default defineMessages({
  research: {
    id: 'map_filter.research',
  },
  universe: {
    id: 'map_filter.universe',
  },
  filterWith: {
    id: 'map_filter.filter_with',
  },
  city: {
    id: 'map_filter.city',
  },
  auto: {
    id: 'dashboard_home_tab.auto',
  },
  mrh: {
    id: 'dashboard_home_tab.mrh',
  },
  epargn: {
    id: 'dashboard_home_tab.epargn',
  },
  allTypes: {
    id: 'map_filter.filter_with.all',
  },
  approvedGarages: {
    id: 'map_filter.filter_with.approved_garages',
  },
  checkAutoExpress: {
    id: 'map_filter.filter_with.check_auto_express',
  },
  agentSA: {
    id: 'map_filter.filter_with.agent_sa',
  },
  amc: {
    id: 'dashboard_home_tab.amc',
  },
  doctors: {
    id: 'map_filter.filter_with.doctors',
  },
  depositPoints: {
    id: 'map_filter.filter_with.deposit_points',
  },
  clinics: {
    id: 'map_filter.filter_with.clinics',
  },
});
